import { useState } from "react";
import axios from "axios";
import { useQuery } from "react-query";
import { useDebounce } from "use-debounce";
import { Value } from "../components/AutoComplete/AutoComplete";

export interface CompanySearchResponse {
  companyId: number;
  displayName: string;
  regNumber: number;
}

interface CompanyValue extends CompanySearchResponse, Value {}

const getCompaniesBySearch = (
  searchText: string,
  type: string
): Promise<CompanyValue[]> =>
  axios
    .get<CompanySearchResponse[]>("/companies/search", {
      params: {
        searchText,
        businessRoleCode: type,
        limit: 20,
        status: "Active",
      },
    })
    .then((res) =>
      res.data.map((item) => ({
        ...item,
        value: item.companyId,
        label: `${item.displayName} (#${item.regNumber})`,
      }))
    );

const useParticipantSearch = (participantType: string) => {
  const [participantSearchText, setParticipantSearchText] = useState("");
  const [debouncedParticipantSearch] = useDebounce(
    participantSearchText.trim().toLowerCase(),
    400
  );

  const participants = useQuery(
    [participantType, debouncedParticipantSearch],
    () => getCompaniesBySearch(debouncedParticipantSearch, participantType),
    {
      retry: false,
      enabled: !!debouncedParticipantSearch.length,
      refetchOnWindowFocus: false,
      keepPreviousData: !!debouncedParticipantSearch.length,
    }
  );

  return {
    searchText: participantSearchText,
    setParticipantSearchText,
    participants: {
      ...participants,
      isFetching:
        participants.isFetching ||
        participantSearchText.trim().toLowerCase() !==
          debouncedParticipantSearch,
    },
  };
};

export default useParticipantSearch;
